import type { event_command_channel_message } from "@zoom/videosdk";
import type { RemoteDataDelegator } from "../../../../core/room/participant/media/MediaDelegator";
import { ZoomEventBus } from "../../../ZoomEventBus";

const COMMAND_CHANNEL_MESSAGE_EVENT_NAME = "command-channel-message";

export class ZoomRemoteDataDelegator implements RemoteDataDelegator {
  readonly kind = "data" as const;
  #eventListener: typeof event_command_channel_message | null = null;

  constructor() {}

  get sid() {
    return this.kind;
  }

  on(
    _: "message",
    eventListener: (message: string) => Promise<null | undefined>,
  ) {
    const eventBus = ZoomEventBus.getInstance();

    const zoomEventHandler = (async (payload) => {
      const { text: message } = payload;
      await eventListener(message);
    }) satisfies typeof event_command_channel_message;
    this.#eventListener = zoomEventHandler;

    eventBus.on(COMMAND_CHANNEL_MESSAGE_EVENT_NAME, zoomEventHandler);

    return () => {};
  }

  off() {
    if (!this.#eventListener) {
      throw new Error(
        "Attempted to deregister ZoomRemoteDataDelegator event listener before registering.",
      );
    }

    const eventBus = ZoomEventBus.getInstance();
    eventBus.off(COMMAND_CHANNEL_MESSAGE_EVENT_NAME, this.#eventListener!);
  }
}
